export default __webpack_public_path__ + "static/media/outstanding-balance.7f3c4cb8.svg";